import { SUBSCRIPTION_BENEFITS } from '../constants'

export const VALID_BUTTON_APPEARANCE = [
  'primary',
  'secondary',
  'tertiary',
  'danger',
  'delete',
  'warning',
  'tertiary-light',
  'subscription',
]
export function buttonAppearanceValidator(value) {
  return VALID_BUTTON_APPEARANCE.includes(value)
}

export const VALID_BUTTON_TYPE = ['fill', 'outline', 'blank']
export function buttonTypeValidator(value) {
  return VALID_BUTTON_TYPE.includes(value)
}

export const VALID_BUTTON_SIZE = ['normal', 'medium', 'small', 'extra-small']
export function buttonSizeValidator(value) {
  return VALID_BUTTON_SIZE.includes(value)
}

export const VALID_FONT_WEIGHT = ['normal', 'light', 'medium', 'semibold', 'bold']
export function fontWeightValidator(value) {
  return VALID_FONT_WEIGHT.includes(value)
}

export const VALID_MODAL_SIZE = ['md', 'lg']
export function modalSizeValidator(value) {
  return VALID_MODAL_SIZE.includes(value)
}

//ui-badge
export const VALID_BADGE_TYPE = [
  'primary',
  'secondary',
  'success',
  'danger',
  'warning',
  'info',
  'light',
  'dark',
  'promo',
  'recommended',
  'not-recommended',
  'rejected',
  'gradient',
  'custom',
  'inactive',
]
export function badgeTypeValidator(value) {
  return VALID_BADGE_TYPE.includes(value)
}

export const VALID_BADGE_SIZE = ['sm', 'md', 'lg', 'xl']
export function badgeSizeValidator(value) {
  return VALID_BADGE_SIZE.includes(value)
}
//ui-alert
export const VALID_ALERT_TYPE = [
  'success',
  'error',
  'warning',
  'info',
  'info-dark',
  'debug',
  'blank',
  'promo',
  'alert',
  'neutral',
  'subscription',
  'info-gradient',
  'primary',
]
export function alertTypeValidator(value) {
  return VALID_ALERT_TYPE.includes(value)
}
export const VALID_ALERT_SIZE = ['default', 'small']
export function alertSizeValidator(value) {
  return VALID_ALERT_SIZE.includes(value)
}

// ui-card
export const VALID_CARD_TYPE = ['default', 'warning', 'error', 'success']
export function cardTypeValidator(value) {
  return VALID_CARD_TYPE.includes(value)
}
export const VALID_CARD_VERSION = ['v2', 'legacy']
export function cardVersionValidator(value) {
  return VALID_CARD_VERSION.includes(value)
}

export function modalImagePropsValidator(value) {
  if (value === null) return true
  const validPositions = ['center', 'top', 'bottom']

  const hasValidSrc = value && typeof value.src === 'string'
  const hasValidObjectPosition =
    !value.objectPosition || validPositions.includes(value.objectPosition)

  return hasValidSrc && hasValidObjectPosition
}

export const imagePositionValidator = (value) => {
  if (!value || typeof value !== 'string') return false

  const keywords = ['center', 'top', 'bottom', 'left', 'right']

  // Split by spaces and filter out empty strings
  const parts = value
    .trim()
    .split(/\s+/)
    .filter((part) => part.length > 0)

  // Empty string is valid (browser default)
  if (parts.length === 0) return true

  if (parts.length === 1) {
    // Single value: keyword, percentage, or length
    const part = parts[0]
    return (
      keywords.includes(part) ||
      /^-?\d*\.?\d+(px|em|rem|%|vh|vw|ex|ch|cm|mm|in|pt|pc)$/.test(part) ||
      /^-?\d+(\.\d+)?%$/.test(part)
    )
  }

  if (parts.length === 2) {
    // Two values: combinations of keywords, percentages, or lengths
    return parts.every(
      (part) =>
        keywords.includes(part) ||
        /^-?\d*\.?\d+(px|em|rem|%|vh|vw|ex|ch|cm|mm|in|pt|pc)$/.test(part) ||
        /^-?\d+(\.\d+)?%$/.test(part)
    )
  }

  // More than 2 values for background-position is invalid
  return false
}

//editorial-elements banner
export function linkTargetValidator(value) {
  return ['_blank', '_self', '_parent', '_top', 'framename'].includes(value)
}

export function subscriptionBenefitsValidator(value) {
  return (
    Array.isArray(value) &&
    value.every((benefit) => Object.values(SUBSCRIPTION_BENEFITS).includes(benefit.code))
  )
}
